import { useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const ClientImport = () => {
  const [xls, setXls] = useState(null);

  const telechargerModele = async () => {
    const { data } = await api.get("/admin/clients/import/modele", { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = "modele-clients-bkprod.xlsx";
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 20000);
  };

  const importer = async () => {
    if (!xls) return toast.error("Choisissez un fichier .xlsx");
    const fd = new FormData();
    fd.append("file", xls);
    try {
      const { data } = await api.post("/admin/clients/import", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`${data.crees} créés · ${data.mis_a_jour} mis à jour · ${data.rattaches_axonaut} rattachés Axonaut · ${data.lignes_ignorees} ignorés`);
      setXls(null);
    } catch (e) {
      toast.error(errMsg(e, "Import impossible"));
    }
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-3" data-testid="import-xls-panel">
      <div className="bk-label">Import de clients (fichier Excel .xlsx)</div>
      <p className="text-sm text-slate-600">
        Colonnes attendues : nom, email, telephone, type_compte, site_nom, site_adresse, materiel_domaine, materiel_designation,
        contrat_libelle, contrat_actif, contrat_echeance. Une ligne par site/matériel. Si l'email existe dans Axonaut, le client est
        automatiquement rattaché à sa société.
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <Button data-testid="import-modele-btn" variant="outline" size="sm" onClick={telechargerModele}>
          Télécharger le modèle
        </Button>
        <input
          data-testid="import-file-input"
          type="file"
          accept=".xlsx"
          onChange={(e) => setXls(e.target.files?.[0] || null)}
          className="text-sm text-slate-600"
        />
        <Button data-testid="import-submit-btn" size="sm" className="bg-[#005CFF] hover:bg-[#0047CC]" onClick={importer}>
          <Upload size={14} className="mr-1" /> Importer
        </Button>
      </div>
    </div>
  );
};

export default ClientImport;
